import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EditorComponent, EditorModule, EditorResizableOptions } from '@progress/kendo-angular-editor';
import { NotificationModule, NotificationService } from '@progress/kendo-angular-notification';
import { LabelModule } from "@progress/kendo-angular-label";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { LoggerService } from '../../shared/logger.service';
import { EditorImageUploadComponent } from '../editor-image-upload/editor-image-upload.component';
import { EditorFileUploaderComponent } from '../editor-file-uploader/editor-file-uploader.component';
import { CasiFileInfo } from '../../common/obj.lib';
import { AuthTokenService } from '../../auth/auth-token.service';

@Component({
  selector: 'casi-kendo-editor',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    FontAwesomeModule,
    // RouterLink, RouterLinkActive,
    EditorModule,
    NotificationModule,
    LabelModule,
    InputsModule,
    ButtonsModule,
    DropDownsModule,
    EditorImageUploadComponent,
    EditorFileUploaderComponent
  ],
  templateUrl: './casi-kendo-editor.component.html',
  styleUrl: './casi-kendo-editor.component.scss'
})
export class CasiKendoEditorComponent {

  private _value: string = '';
  @Input() set value(val: string) {
    this._value = val;
  }
  get value() {
    return this._value;
  }

  private _recordId: number = 0;
  @Input() set recordId(val: number) {
    this._recordId = val;
  }
  get recordId() {
    return this._recordId;
  }

  private _tableName: string = 'terms_conditions';
  @Input() set tableName(val: string) {
    this._tableName = val;
  }
  get tableName() {
    return this._tableName;
  }

  @Output() onValueChange: EventEmitter<string> = new EventEmitter();
  @Output() onImageUploaded: EventEmitter<any> = new EventEmitter();
  @Output() onFileUploaded: EventEmitter<CasiFileInfo[]> = new EventEmitter();

  @ViewChild("uploadDialogImage") public dialogImage: EditorImageUploadComponent = <EditorImageUploadComponent>{};
  @ViewChild("uploadDialogFile") public dialogFile: EditorFileUploaderComponent = <EditorFileUploaderComponent>{};
  @Output() @ViewChild("editor") private editor: EditorComponent = <EditorComponent>{};

  public resizable: boolean | EditorResizableOptions = {
    minWidth: 300,
    minHeight: 150,
    maxWidth: 1200,
    maxHeight: 550,
  };

  constructor(
    private logger: LoggerService
  ) {
  }

  public valueChange(value: string): void {
    // this.logger.debug(`valueChange...`, value);
    this.onValueChange.emit(value);
  }

  public openImageUpload() {
    setTimeout(() => this.dialogImage.open(), 200);
  }

  public openFileUpload() {
    setTimeout(() => this.dialogFile.open(), 200);
  }

  public onImageLoaded(args: any): void {
    this.logger.debug('onImageLoaded...', args);
    this.onImageUploaded.emit(args);
  }

  public onFileLoaded(args: CasiFileInfo[]): void {
    this.logger.debug('onFileLoaded...', args);
    for (let link of args) {
      this.logger.debug('onFileLoaded:link: ', link);
      this.value = `${this.value}${link.buildLink()}`
      this.logger.debug('onFileLoaded:value: ', this.value);
    }
    this.onValueChange.emit(this.value);
    // this.onFileUploaded.emit(args);
  }

}
